import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { Parking } from 'src/features/parkingManagement/types/parking';
import type { GeneralSmartParkError } from 'src/types';

type EnableBoricaPaymentsFnType = typeof enableBoricaPayments;

export type EnableBoricaPaymentsDTO = {
    parkingId: string;
};

const enableBoricaPayments = ({ parkingId, ...data }: EnableBoricaPaymentsDTO): Promise<Parking> => {
    return axios.post(
        formatResourcePath(`/parkings/${parkingId}/enable-borica-payments/`, {
            parkingId,
        }),
        data,
    );
};

interface UseMutationOptions extends MutationConfig<EnableBoricaPaymentsFnType, GeneralSmartParkError> {}

export const useEnableBoricaPayments = (options: UseMutationOptions) =>
    useMutation({
        mutationFn: enableBoricaPayments,
        ...options,
    });
